'use client';

import { Stack } from '@backyard-ui/core';

import {
  ProductsCarousel,
  ProductsCarouselSkeleton,
} from '@/presenters/components/common/ProductsCarousel';
import { useCrossesProducts } from '@/presenters/hooks/catalog/product/use-crosses-products';
import { useProductStore } from '@/presenters/store/catalog/product';

export default function Complementaries() {
  const productId = useProductStore((state) => state.product._id);
  const initialCrosses = useProductStore((state) => state.crossesProducts);

  const { data: crosses, isFetching } = useCrossesProducts(productId, {
    initialData: initialCrosses && { data: initialCrosses },
  });

  if (isFetching) {
    return <ProductsCarouselSkeleton testId="skeleton" />;
  }

  if (!crosses?.data || crosses.data.length <= 0) {
    return null;
  }

  return (
    <Stack direction="column" spacing="8">
      {crosses.data.map((carousel, carouselIndex) => (
        <div
          key={`${carousel.slug}${carouselIndex}`}
          data-testid="complementary-carousel"
        >
          <ProductsCarousel
            partnerName="elastic search"
            type="recommendedProducts"
            title={carousel.title}
            items={carousel.products}
          />
        </div>
      ))}
    </Stack>
  );
}
